<template>
  <div
    id="app"
    class="
      h-full
      grid
      justify-items-center
      lg:content-center
      content-start
      relative
    "
  >
    <div class="container mx-auto p-4">
      <div class="flex flex-wrap items-center">
        <div class="flex flex-col lg:w-1/2 w-full">
          <div class="flex items-center animate__animated animate__fadeInDown">
            <div>
              <img
                src="./assets/logo.png"
                class="object-scale-down w-16 mr-2"
                alt=""
              />
            </div>
            <div>
              <span class="text-4xl font-bold">BEMOG</span>
              <span class="text-4xl ml-1 text-green-500 font-bold">Links</span>
              <div
                class="
                  text-sm text-gray-500
                  animate__animated animate__fadeInUp
                "
              >
                "Responding in Unity to Christ's Mission"
              </div>
            </div>
          </div>
        </div>

        <div
          class="
            flex
            lg:w-1/2
            w-full
            lg:justify-end
            justify-center
            gap-2
            lg:mt-0
            mt-6
          "
        >
          <fa
            size="lg"
            class="cursor-pointer text-blue-600"
            :icon="['fab', 'facebook']"
          ></fa>
          <fa
            size="lg"
            class="cursor-pointer text-blue-400"
            :icon="['fab', 'twitter']"
          ></fa>
          <fa
            size="lg"
            class="cursor-pointer text-red-500"
            :icon="['fab', 'youtube']"
          ></fa>
          <fa
            size="lg"
            class="cursor-pointer text-purple-500"
            :icon="['fab', 'instagram']"
          ></fa>
        </div>
      </div>
    </div>
    <div
      class="
        flex
        w-full
        justify-center
        items-center
        h-64
        border-t-8 border-b-8 border-gray-500
        animate__animated animate__fadeIn
      "
      id="header"
    ></div>
    <div class="bg-gray-200 w-full">
      <div class="container mx-auto p-4">
        <div class="p-4">Click on the links to open new window.</div>

        <div class="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <link-card
            title="Home"
            description="BEM Olive Garden main website"
            icon="home"
            iconColor="text-green-600"
            link="https://sibog.org"
          />
          <link-card
            title="Connect"
            description="First time visiting or need prayer? Connect with us."
            icon="link"
            iconColor="text-yellow-600"
            link="https://connect.sibog.org"
          />
          <link-card
            title="YouTube"
            description="Stream our services here."
            :icon="['fab', 'youtube']"
            iconColor="text-red-500"
            link="https://www.youtube.com/c/bemolivegarden"
          />
          <link-card
            title="Online Church"
            description="Join our worship service with online bible ready on the go here."
            :icon="['fas', 'video']"
            iconColor="text-red-500"
            link="https://bemolivegarden.online.church/"
          />
          <link-card
            title="Volunteer"
            description="Called to serve the Lord? Join any of our ministry today."
            icon="users"
            iconColor="text-red-500"
            link="https://volunteer.sibog.org/"
          />
          <div
            @click="showAlert()"
            class="
              animate__animated animate__fadeInDown
              card
              p-5
              w-full
              cursor-pointer
              rounded-lg
              hover:bg-gray-800 hover:shadow-lg
              border-b-4 border-green-600
              hover:text-white
              hover:border-gray-800
              hover:border
              hover:underline
            "
          >
            <div class="flex flex-col">
              <div class="text-xl font-bold">
                <fa icon="money-check-alt" class="text-purple-400 mr-2"></fa
                >Tithings & Offering
              </div>
              <div class="text-sm">
                Tithing and offerings can be done via online transaction.
              </div>
            </div>
          </div>

          <link-card
            title="Core Values"
            description="Wanted to know more about who we are? Find out now."
            icon="key"
            iconColor="text-yellow-400"
            link="http://www.sibog.org/core-values/"
          />
        </div>
      </div>
    </div>
    <router-view class="mb-6" />
    <div class="py-4 flex flex-col justify-center items-center">
      <div class="text-sm">
        <span class="font-bold">
          Copyright <fa :icon="['far', 'copyright']" /> 2022</span
        >
        | BEM Olive Garden
      </div>
    </div>
  </div>
</template>

<script>
import LinkCard from "./components/LinkCard.vue";
export default {
  components: { LinkCard },
  name: "AppMain",
  metaInfo() {
    return {
      title: "BEMOG | Quick Links",
    };
  },
  methods: {
    showAlert() {
      this.$swal({
        title: "Tithing & Givings",
        allowOutsideClick: false,
        confirmButtonText: "Close",
        html:
          "You can send your tithing and offerings to the following account:<br/><br/>" +
          "<span class='font-bold'>Hong Leong Bank</span><br/>" +
          "<span class='text-xl text-muted'>02900047381</span><br/>" +
          "<span class='text-xl text-muted'>Sidang Injil Borneo Olive Garden</span>",
      });
    },
  },
};
</script>

<style lang="scss">
#header {
  background: url("./assets/main-bg.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
